// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("image2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout */
.quiz-layout {
    display: flex;
    width: 100%;
    max-width: 1512px;
    height: 982px;
}

.quiz-left {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: -1;
    max-width: 676px;
    width: 100%;
    height: 982px;

    box-sizing: border-box !important;
}

.quiz-left::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 0;
}

.quiz-left h1 {
    font-size: 48px;
    margin-bottom: 20px;
    z-index: 1;
    padding-left: 114px;
    padding-right: 50px;
}

.quiz-left p {
    font-size: 18px;
    line-height: 1.5;
    z-index: 1;
    padding-left: 114px;
    padding-right: 50px;
}

.quiz-right {
    flex: 1 1;
    padding: 40px;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    justify-content: center;
    text-align: left;
    flex-direction: column;
    align-items: center;
}

/* Progress Bar */
.progress-bar {
    position: absolute;
    height: 10px;
    background-color: #ddd;
    width: 100%;
    margin-bottom: 20px;
    z-index: 1;
    top: 120px;
}

.progress-filled {
    height: 100%;
    background: var(--red, #EC5372);
    transition: width 0.3s ease;
    z-index: 1;
}

/* Quiz Content */
.quiz-content {
    background: white;
    max-width: 578px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: left; /* Ensure text is aligned to the left */
}

.quiz-content h3 {
    color: var(--blue, #458BEA);
    font-size: 24px;
    font-style: normal;
    font-weight: 900;
    line-height: 150%; /* 36px */
    text-align: left; /* Ensure text is aligned to the left */
}

.quiz-content h4 {
    margin-top: 20px;
    margin-bottom: 20px;
    color: #524643;
    font-family: Inter;
    font-size: 34px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 40.8px */
    text-align: left; /* Ensure text is aligned to the left */
}

.quiz-content .options {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.quiz-content .option {
    margin-bottom: 10px;
    width: 100%;
    color: #524643;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 31.2px */
}

.quiz-content .option input {
    display: none;
}

.quiz-content .option label {
    display: flex;
    align-items: center;
    background-color: #f0f0f0;
    border-radius: 20px;
    border: 2px solid transparent;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
    height: auto;
    min-height: 132px;
    flex-shrink: 0;
    background: #F5F5F5;
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
}

.quiz-content .option .label-text {
    color: #524643;
    font-family: Inter;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
}

.quiz-content .option input:checked + label {
    background-color: #e0e0e0;
    border-color: #007bff;
    border-radius: 20px;
    background: var(--light-blue, #E4EEFC);
}

.quiz-content .option label:hover {
    background-color: #e9e9e9;
}

.quiz-content button {
    background-color: #007bff;
    color: white;
    padding: 15px 30px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s, opacity 0.3s;
    align-self: center; /* Center the button */
    margin-top: auto;
}

.quiz-content button.active:hover {
    background-color: #0056b3;
}

.quiz-content button.inactive {
    opacity: 0.5;
    cursor: not-allowed;
}

.quiz-content button.inactive:hover {
    background-color: #007bff;
}

/* Media query for mobile devices */
@media screen and (max-width: 1000px) {
  .quiz-layout {
    flex-direction: column;
    height: auto;
  }

  .quiz-left {
    width: 100%;
    max-width: 100%;
    height: auto;
    padding: 20px 10px; /* Reduced horizontal padding */
    box-sizing: border-box;
    position: relative;
    padding-bottom: 40px;
  }

  .quiz-left h1 {
    font-size: 24px; /* Slightly smaller font */
    margin: 10px 0; /* Vertical margin only */
    padding: 0; /* Remove padding */
  }

  .quiz-left p {
    font-size: 14px;
    margin: 10px 0; /* Vertical margin only */
    padding: 0; /* Remove padding */
  }

  .quiz-right {
    width: 100%;
    padding: 20px;
  }

  .progress-bar {
    position: absolute;
    top: auto; /* Remove top positioning */
    bottom: 0; /* Position at the bottom of quiz-left */
    left: 0;
    width: 100%;
    margin-bottom: 0; /* Remove bottom margin */
  }

  .quiz-content {
    max-width: 100%;
  }

  .quiz-content h3 {
    font-size: 18px;
  }

  .quiz-content h4 {
    font-size: 20px;
  }

  .quiz-content .option label {
    font-size: 16px;
    height: auto;
    padding: 12px;
  }

  .quiz-content button {
    font-size: 16px;
    padding: 12px 24px;
  }

  /* Adjustments for quiz end screen */
  .quiz-end-screen {
    height: auto;
    min-height: 100vh;
    padding: 20px 10px;
  }

  .quiz-end-box {
    width: 95%;
    height: auto;
    padding: 20px 10px;
    margin-top: 80px; /* Adjust this value to accommodate the title */
    overflow-y: auto; /* Allow vertical scrolling if content overflows */
    max-height: calc(100vh - 150px); /* Adjust based on your needs */
  }

  .quiz-end-screen .rep-card {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    height: 450px; /* Set a fixed height, adjust as needed */
    display: flex;
    flex-direction: column;
  }

  .quiz-end-screen   .rep-card .mask-group {
    width: 100%;
    height: 200px; /* Set a fixed height for the image */
    object-fit: cover; /* Ensure the image covers the area without stretching */
  }

  .quiz-end-screen  .rep-card .content {
    padding: 10px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .quiz-end-screen  .rep-card .text-wrapper,
  .quiz-end-screen  .rep-card .div {
    font-size: 14px;
    margin-bottom: 5px;
  }

  .quiz-end-screen .rep-card .topics-container {
    flex-wrap: wrap;
    justify-content: center;
  }

  .quiz-end-screen  .rep-card .topic {
    font-size: 12px;
    margin: 2px;
    padding: 4px 8px;
  }

  .score-comparison {
    width: 100%;
    overflow-x: auto;
  }
}

/* Additional styles for better mobile compatibility */
@media screen and (max-width: 480px) {
  .quiz-left h1 {
    font-size: 22px;
  }

  .quiz-left p {
    font-size: 13px;
  }

  .quiz-content h3 {
    font-size: 16px;
  }

  .quiz-content h4 {
    font-size: 18px;
  }

  .quiz-content .option .label-text {
    font-size: 13px;
  }

  .quiz-end-title {
    font-size: 18px;
  }

  .home-button {
    padding: 10px 20px;
    font-size: 16px;
  }
}

.quiz-end-screen {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; /* Center items horizontally */
    z-index: -1;
    width: 100%;
    height: 982px;
    box-sizing: border-box !important;
    z-index: 1; /* This ensures content within is clickable */
}

.quiz-end-box {
    max-width: 1060px;
    width: 100%;
    height: 695px;
    flex-shrink: 0;
    border-radius: 31px;
    background: #FFF;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    z-index: 1; /* This ensures content within is clickable */
    color: black;
}

.quiz-end-title {
    min-width: 375px;
    height: 71px;
    flex-shrink: 0;
    border-radius: 40px;
    background: var(--blue, #458BEA);
    display: flex;
    justify-content: center; /* Center text horizontally */
    align-items: center; /* Center text vertically */
    color: white; /* Ensure text is visible */
    position: absolute;
    top: 90px;
    z-index: 2; /* This ensures content within is clickable */
    padding: 0 20px; /* Add horizontal padding */
    box-sizing: border-box; /* Include padding in width calculation */

    color: #FFF;
    font-family: Inter;
    font-size: 34px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 40.8px */
    white-space: nowrap; /* Prevent text from wrapping */
    max-width: 90%; /* Limit maximum width to 90% of parent container */
}


.quiz-end-gallery .similarreps {
    width: 80%;
    height: 100px !important;
}


.quiz-end-desc {
 color: black;
 margin-bottom: 10px;
}


.home-button {
    background-color: #007bff;
    color: white;
    padding: 15px 30px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s;
    align-self: center;
    margin-top: 20px;
    z-index: 1000; /* Ensure this is on top */
    position: relative; 
}

.home-button:hover {
    background-color: #0056b3;
}

/* Responsive styles for mobile */
.quiz-content label {
    font-size: 16px; /* Default font size */
}

@media (max-width: 768px) {
    .quiz-content label {
        font-size: 14px; /* Smaller font size for mobile */
    }

    .quiz-content h3 {
        font-size: 18px; /* Adjust the question number size if needed */
    }

    .quiz-content h4 {
        font-size: 16px; /* Adjust the question text size if needed */
    }

    .quiz-content button {
        font-size: 14px; /* Adjust the button text size if needed */
        padding: 8px 16px; /* Adjust button padding for better touch targets */
    }

    .quiz-content .option label {
        padding: 15px;
        min-height: 80px;
    }

    .quiz-content .option .label-text {
        font-size: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/QuizComponent/style.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yDAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,aAAa;;IAEb,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,2BAA2B;IAC3B,UAAU;AACd;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,gBAAgB,EAAE,uCAAuC;AAC7D;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,oDAAoD;IACpD,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,+CAA+C;IAC/C,kBAAkB,EAAE,sBAAsB;IAC1C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB,EAAE,+BAA+B;IACnD,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,eAAe,EAAE,0BAA0B;IAC3C,cAAc,EAAE,yBAAyB;IACzC,UAAU,EAAE,mBAAmB;EACjC;;EAEA;IACE,eAAe;IACf,cAAc,EAAE,yBAAyB;IACzC,UAAU,EAAE,mBAAmB;EACjC;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS,EAAE,2BAA2B;IACtC,SAAS,EAAE,wCAAwC;IACnD,OAAO;IACP,WAAW;IACX,gBAAgB,EAAE,yBAAyB;EAC7C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,oCAAoC;EACpC;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB,EAAE,+CAA+C;IACjE,gBAAgB,EAAE,kDAAkD;IACpE,+BAA+B,EAAE,+BAA+B;EAClE;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa,EAAE,yCAAyC;IACxD,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa,EAAE,qCAAqC;IACpD,iBAAiB,EAAE,wDAAwD;EAC7E;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;;IAEE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;IACI,kBAAkB;IAClB,yDAAmC;IACnC,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB,EAAE,8BAA8B;IACnD,WAAW;IACX,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,UAAU,EAAE,6CAA6C;AAC7D;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,8BAA8B;IACvD,mBAAmB,EAAE,gCAAgC;IACrD,UAAU,EAAE,6CAA6C;IACzD,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,uBAAuB,EAAE,6BAA6B;IACtD,mBAAmB,EAAE,2BAA2B;IAChD,YAAY,EAAE,2BAA2B;IACzC,kBAAkB;IAClB,SAAS;IACT,UAAU,EAAE,6CAA6C;IACzD,eAAe,EAAE,2BAA2B;IAC5C,sBAAsB,EAAE,yCAAyC;;IAEjE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;IAC9B,mBAAmB,EAAE,+BAA+B;IACpD,cAAc,EAAE,mDAAmD;AACvE;;;AAGA;IACI,UAAU;IACV,wBAAwB;AAC5B;;;AAGA;CACC,YAAY;CACZ,mBAAmB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa,EAAE,0BAA0B;IACzC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iCAAiC;AACjC;IACI,eAAe,EAAE,sBAAsB;AAC3C;;AAEA;IACI;QACI,eAAe,EAAE,iCAAiC;IACtD;;IAEA;QACI,eAAe,EAAE,8CAA8C;IACnE;;IAEA;QACI,eAAe,EAAE,4CAA4C;IACjE;;IAEA;QACI,eAAe,EAAE,0CAA0C;QAC3D,iBAAiB,EAAE,mDAAmD;IAC1E;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Layout */\n.quiz-layout {\n    display: flex;\n    width: 100%;\n    max-width: 1512px;\n    height: 982px;\n}\n\n.quiz-left {\n    position: relative;\n    background-image: url('image.png');\n    background-size: cover;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    z-index: -1;\n    max-width: 676px;\n    width: 100%;\n    height: 982px;\n\n    box-sizing: border-box !important;\n}\n\n.quiz-left::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 0;\n}\n\n.quiz-left h1 {\n    font-size: 48px;\n    margin-bottom: 20px;\n    z-index: 1;\n    padding-left: 114px;\n    padding-right: 50px;\n}\n\n.quiz-left p {\n    font-size: 18px;\n    line-height: 1.5;\n    z-index: 1;\n    padding-left: 114px;\n    padding-right: 50px;\n}\n\n.quiz-right {\n    flex: 1;\n    padding: 40px;\n    background: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    justify-content: center;\n    text-align: left;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Progress Bar */\n.progress-bar {\n    position: absolute;\n    height: 10px;\n    background-color: #ddd;\n    width: 100%;\n    margin-bottom: 20px;\n    z-index: 1;\n    top: 120px;\n}\n\n.progress-filled {\n    height: 100%;\n    background: var(--red, #EC5372);\n    transition: width 0.3s ease;\n    z-index: 1;\n}\n\n/* Quiz Content */\n.quiz-content {\n    background: white;\n    max-width: 578px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    text-align: left; /* Ensure text is aligned to the left */\n}\n\n.quiz-content h3 {\n    color: var(--blue, #458BEA);\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 900;\n    line-height: 150%; /* 36px */\n    text-align: left; /* Ensure text is aligned to the left */\n}\n\n.quiz-content h4 {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    color: #524643;\n    font-family: Inter;\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%; /* 40.8px */\n    text-align: left; /* Ensure text is aligned to the left */\n}\n\n.quiz-content .options {\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\n.quiz-content .option {\n    margin-bottom: 10px;\n    width: 100%;\n    color: #524643;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%; /* 31.2px */\n}\n\n.quiz-content .option input {\n    display: none;\n}\n\n.quiz-content .option label {\n    display: flex;\n    align-items: center;\n    background-color: #f0f0f0;\n    border-radius: 20px;\n    border: 2px solid transparent;\n    cursor: pointer;\n    transition: background-color 0.3s, border-color 0.3s;\n    height: auto;\n    min-height: 132px;\n    flex-shrink: 0;\n    background: #F5F5F5;\n    padding: 20px;\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.quiz-content .option .label-text {\n    color: #524643;\n    font-family: Inter;\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n}\n\n.quiz-content .option input:checked + label {\n    background-color: #e0e0e0;\n    border-color: #007bff;\n    border-radius: 20px;\n    background: var(--light-blue, #E4EEFC);\n}\n\n.quiz-content .option label:hover {\n    background-color: #e9e9e9;\n}\n\n.quiz-content button {\n    background-color: #007bff;\n    color: white;\n    padding: 15px 30px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 18px;\n    transition: background-color 0.3s, opacity 0.3s;\n    align-self: center; /* Center the button */\n    margin-top: auto;\n}\n\n.quiz-content button.active:hover {\n    background-color: #0056b3;\n}\n\n.quiz-content button.inactive {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.quiz-content button.inactive:hover {\n    background-color: #007bff;\n}\n\n/* Media query for mobile devices */\n@media screen and (max-width: 1000px) {\n  .quiz-layout {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .quiz-left {\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    padding: 20px 10px; /* Reduced horizontal padding */\n    box-sizing: border-box;\n    position: relative;\n    padding-bottom: 40px;\n  }\n\n  .quiz-left h1 {\n    font-size: 24px; /* Slightly smaller font */\n    margin: 10px 0; /* Vertical margin only */\n    padding: 0; /* Remove padding */\n  }\n\n  .quiz-left p {\n    font-size: 14px;\n    margin: 10px 0; /* Vertical margin only */\n    padding: 0; /* Remove padding */\n  }\n\n  .quiz-right {\n    width: 100%;\n    padding: 20px;\n  }\n\n  .progress-bar {\n    position: absolute;\n    top: auto; /* Remove top positioning */\n    bottom: 0; /* Position at the bottom of quiz-left */\n    left: 0;\n    width: 100%;\n    margin-bottom: 0; /* Remove bottom margin */\n  }\n\n  .quiz-content {\n    max-width: 100%;\n  }\n\n  .quiz-content h3 {\n    font-size: 18px;\n  }\n\n  .quiz-content h4 {\n    font-size: 20px;\n  }\n\n  .quiz-content .option label {\n    font-size: 16px;\n    height: auto;\n    padding: 12px;\n  }\n\n  .quiz-content button {\n    font-size: 16px;\n    padding: 12px 24px;\n  }\n\n  /* Adjustments for quiz end screen */\n  .quiz-end-screen {\n    height: auto;\n    min-height: 100vh;\n    padding: 20px 10px;\n  }\n\n  .quiz-end-box {\n    width: 95%;\n    height: auto;\n    padding: 20px 10px;\n    margin-top: 80px; /* Adjust this value to accommodate the title */\n    overflow-y: auto; /* Allow vertical scrolling if content overflows */\n    max-height: calc(100vh - 150px); /* Adjust based on your needs */\n  }\n\n  .quiz-end-screen .rep-card {\n    width: 100%;\n    max-width: 300px;\n    margin: 0 auto;\n    height: 450px; /* Set a fixed height, adjust as needed */\n    display: flex;\n    flex-direction: column;\n  }\n\n  .quiz-end-screen   .rep-card .mask-group {\n    width: 100%;\n    height: 200px; /* Set a fixed height for the image */\n    object-fit: cover; /* Ensure the image covers the area without stretching */\n  }\n\n  .quiz-end-screen  .rep-card .content {\n    padding: 10px;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .quiz-end-screen  .rep-card .text-wrapper,\n  .quiz-end-screen  .rep-card .div {\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n\n  .quiz-end-screen .rep-card .topics-container {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .quiz-end-screen  .rep-card .topic {\n    font-size: 12px;\n    margin: 2px;\n    padding: 4px 8px;\n  }\n\n  .score-comparison {\n    width: 100%;\n    overflow-x: auto;\n  }\n}\n\n/* Additional styles for better mobile compatibility */\n@media screen and (max-width: 480px) {\n  .quiz-left h1 {\n    font-size: 22px;\n  }\n\n  .quiz-left p {\n    font-size: 13px;\n  }\n\n  .quiz-content h3 {\n    font-size: 16px;\n  }\n\n  .quiz-content h4 {\n    font-size: 18px;\n  }\n\n  .quiz-content .option .label-text {\n    font-size: 13px;\n  }\n\n  .quiz-end-title {\n    font-size: 18px;\n  }\n\n  .home-button {\n    padding: 10px 20px;\n    font-size: 16px;\n  }\n}\n\n.quiz-end-screen {\n    position: relative;\n    background-image: url('image2.png');\n    background-size: cover;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; /* Center items horizontally */\n    z-index: -1;\n    width: 100%;\n    height: 982px;\n    box-sizing: border-box !important;\n    z-index: 1; /* This ensures content within is clickable */\n}\n\n.quiz-end-box {\n    max-width: 1060px;\n    width: 100%;\n    height: 695px;\n    flex-shrink: 0;\n    border-radius: 31px;\n    background: #FFF;\n    display: flex;\n    flex-direction: column;\n    justify-content: center; /* Center content vertically */\n    align-items: center; /* Center content horizontally */\n    z-index: 1; /* This ensures content within is clickable */\n    color: black;\n}\n\n.quiz-end-title {\n    min-width: 375px;\n    height: 71px;\n    flex-shrink: 0;\n    border-radius: 40px;\n    background: var(--blue, #458BEA);\n    display: flex;\n    justify-content: center; /* Center text horizontally */\n    align-items: center; /* Center text vertically */\n    color: white; /* Ensure text is visible */\n    position: absolute;\n    top: 90px;\n    z-index: 2; /* This ensures content within is clickable */\n    padding: 0 20px; /* Add horizontal padding */\n    box-sizing: border-box; /* Include padding in width calculation */\n\n    color: #FFF;\n    font-family: Inter;\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%; /* 40.8px */\n    white-space: nowrap; /* Prevent text from wrapping */\n    max-width: 90%; /* Limit maximum width to 90% of parent container */\n}\n\n\n.quiz-end-gallery .similarreps {\n    width: 80%;\n    height: 100px !important;\n}\n\n\n.quiz-end-desc {\n color: black;\n margin-bottom: 10px;\n}\n\n\n.home-button {\n    background-color: #007bff;\n    color: white;\n    padding: 15px 30px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 18px;\n    transition: background-color 0.3s;\n    align-self: center;\n    margin-top: 20px;\n    z-index: 1000; /* Ensure this is on top */\n    position: relative; \n}\n\n.home-button:hover {\n    background-color: #0056b3;\n}\n\n/* Responsive styles for mobile */\n.quiz-content label {\n    font-size: 16px; /* Default font size */\n}\n\n@media (max-width: 768px) {\n    .quiz-content label {\n        font-size: 14px; /* Smaller font size for mobile */\n    }\n\n    .quiz-content h3 {\n        font-size: 18px; /* Adjust the question number size if needed */\n    }\n\n    .quiz-content h4 {\n        font-size: 16px; /* Adjust the question text size if needed */\n    }\n\n    .quiz-content button {\n        font-size: 14px; /* Adjust the button text size if needed */\n        padding: 8px 16px; /* Adjust button padding for better touch targets */\n    }\n\n    .quiz-content .option label {\n        padding: 15px;\n        min-height: 80px;\n    }\n\n    .quiz-content .option .label-text {\n        font-size: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
